import moment from 'moment';
import 'moment-timezone';

export default {
    methods: {
        processBookings: function(provider, bookings) {
            if (window.getSharedLang() === 'zh') {
                moment.locale('zh-tw');
            } else {
                moment.locale('en');
            }

            for (var i in bookings) {
                var b = bookings[i];
    			b.display_datetime = moment.utc(b.start_datetime).tz(provider.timezone).format('YYYY-MM-DD A h:mm');
    			b.display_end_datetime = moment.utc(b.end_datetime).tz(provider.timezone).format('YYYY-MM-DD A h:mm');
    			b.display_duration = moment(b.start_datetime).format('A h:mm') + ' ' + this.$t('general.to') + ' ' + moment(b.end_datetime).format('A h:mm');
                b.display_datetime_duration = b.display_datetime + ' - ' + moment(b.end_datetime).format('h:mm');
                b.display_created_at = moment.utc(b.created_at).tz(provider.timezone).format('YYYY-MM-DD A h:mm');

                if (b.service.allow_custom_duration) {
                    const startDate = moment.utc(b.start_datetime).tz(provider.timezone).format('YYYY-MM-DD');
                    const endDate = moment.utc(b.end_datetime).tz(provider.timezone).format('YYYY-MM-DD');
                    if (startDate === endDate) {
                        b.custom_duration_display_datetime = moment.utc(b.start_datetime).tz(provider.timezone).format('YYYY-MM-DD A h:mm') + ' <br>' + this.$t('general.to') + '<br>' + moment.utc(b.end_datetime).tz(provider.timezone).format('A h:mm')
                    } else {
                        b.custom_duration_display_datetime = moment.utc(b.start_datetime).tz(provider.timezone).format('YYYY-MM-DD A h:mm') + '<br>' + this.$t('general.to') + '<br>' + moment.utc(b.end_datetime).tz(provider.timezone).format('YYYY-MM-DD A h:mm')
                    }
                }

                if (b.status_changed_at && b.status_changed_at !== '2020-01-01T00:00:00.000000Z') {
                    b.display_status_changed_at = moment.utc(b.status_changed_at).tz(provider.timezone).format('YYYY-MM-DD A h:mm');
                }
    			if (!b.note) {
    				this.$set(b, 'note', ''); // for editabletext does not accept null value
                }

                if (b.answers) {
                    for (var j in b.answers) {
                        const answer = b.answers[j];
                        if (answer.question.content) {
                            answer.question.parsedContent = JSON.parse(answer.question.content);
                        }
                        try {
                            answer.parsedContent = JSON.parse(answer.content);
                        } catch (e) {
                            answer.parsedContent = null;
                        }
                    }
                }
            }
        }
    }
}
